"use client";
import React, { useEffect } from "react";
import Loader from "@/components/common/Loader";
import { usePathname } from "next/navigation";

// const Loading: React.FC = () => {
  const Loading: React.FC<{ onRouteChangeComplete?: () => void }> = ({ onRouteChangeComplete }) => {
    const pathname = usePathname();
    useEffect(() => {
      if (onRouteChangeComplete) {
        onRouteChangeComplete();
      }
    }, [pathname, onRouteChangeComplete]);
  return <Loader />;
};

export default Loading;
